import { authLayout } from "../helpers/withAuth";

export const toolRoutes = {
  path: "tools",
  ...authLayout("Tools", [
    {
      path: "/tools/compare",
      lazy: () =>
        import("../../modules/tools/compare").then((m) => ({
          Component: m.CompareTool,
        })),
    },
    {
      path: "/tools/google-search-trends",
      lazy: () =>
        import("../../modules/tools/google-realtime").then((m) => ({
          Component: m.default,
        })),
    },
    {
      path: "/tools/google-search-trends/searches/:id",
      lazy: () =>
        import(
          "../../modules/tools/google-realtime/GoogleRealtimeSearchReport"
        ).then((m) => ({ Component: m.default })),
    },
    {
      path: "/tools/twitter-query-trends",
      lazy: () =>
        import("../../modules/tools/twitter/query-tool").then((m) => ({
          Component: m.default,
        })),
    },
    {
      path: "/tools/twitter-query-trends/searches/:id",
      lazy: () =>
        import("../../modules/tools/twitter/query-tool/results").then((m) => ({
          Component: m.default,
        })),
    },
    {
      path: "/tools/offline-reports",
      lazy: () =>
        import("../../modules/tools/offline-reports").then((m) => ({
          Component: m.default,
        })),
    },
    {
      path: "/tools/report-builder",
      lazy: () =>
        import("../../modules/tools/report-builder").then((m) => ({
          Component: m.default,
        })),
    },
    {
      path: "/tools/report-builder/report/:id",
      lazy: () =>
        import(
          "../../modules/tools/report-builder/components/ReportResults/ReportResults"
        ).then((m) => ({ Component: m.ReportResults })),
    },
    {
      path: "/tools/streaming-window",
      lazy: () =>
        import("../../modules/dashboards/streaming-window").then((m) => ({
          Component: m.default,
        })),
    },
  ]),
};
